import { FC, useState, useEffect } from "react"
import styled from "styled-components"
import { useInView } from "react-intersection-observer"

import { ContentfulProductWithShopifyData } from "@lib/types"
import { ProductThumbnail } from "@components/ui"

interface Props {
  products: ContentfulProductWithShopifyData[]
}

export const ProductGrid: FC<Props> = ({ products }) => {
  const [productsToShow, setProductsToShow] = useState<number>(8)
  const { ref, inView } = useInView()

  useEffect(() => {
    if (productsToShow < products.length) {
      setProductsToShow(productsToShow + 8)
    }
  }, [inView])

  return (
    <StyledProductGrid>
      {products.slice(0, productsToShow).map((product: any) => {
        return (
          <Product key={product.sys.id}>
            <ProductThumbnail product={product} />
          </Product>
        )
      })}
      <div ref={ref} />
    </StyledProductGrid>
  )
}

const StyledProductGrid = styled.ul`
  display: grid;
  grid-template-columns: repeat(auto-fill, calc(50% - 0.7rem));
  column-gap: 1.4rem;

  @media (min-width: ${({ theme }) => theme.breakpoint.md}px) {
    padding: 0 2rem;
    grid-template-columns: repeat(4, 1fr);
    grid-gap: 2.6rem;
  }

  @media (min-width: ${({ theme }) => theme.breakpoint.xl}px) {
    padding: 0;
  }
`

const Product = styled.div`
  margin: 0 0 2.4rem;

  @media (min-width: ${({ theme }) => theme.breakpoint.md}px) {
    margin: 0;
  }
`
